import React from "react";

const DeliveryOrderItemTable = ({ data }: { data: any }) => {
  const productData = data || [];

  const warehouseNames: string[] = Array.from(
    new Set(
      productData
        .flatMap((p: any) => p.warehouses.map((w: any) => w.warehouse_name))
        .filter(Boolean)
    )
  );

  return (
    <div className="standard-table-wrapper">
      <table className="standard-table border border-gray-300 text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 border text-left">SKU</th>
            <th className="px-4 py-2 border text-left">Product Code</th>
            <th className="px-4 py-2 border text-left">Product Name</th>
            <th className="px-4 py-2 border text-left">Total</th>
            {warehouseNames.map((wh, idx) => (
              <th key={idx} className="px-4 py-2 border text-left">
                {wh}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {productData.map((product: any, idx: number) => {
            const totalQty = product.warehouses.reduce(
              (sum: number, w: any) => sum + Number(w.total_base_qty || 0),
              0
            );

            return (
              <tr key={idx} className="hover:bg-gray-50">
                <td className="px-4 py-2 border">{product.unit_name}</td>
                <td className="px-4 py-2 border">{product.product_code}</td>
                <td className="px-4 py-2 border">{product.product_name}</td>
                <td className="px-4 py-2 border">{totalQty}</td>
                {warehouseNames.map((whName, i) => {
                  const match = product.warehouses.find(
                    (w: any) => w.warehouse_name === whName
                  );
                  return (
                    <td key={i} className="px-4 py-2 border text-left ">
                      {match ? match.total_base_qty : 0}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DeliveryOrderItemTable;
